import { Box } from '@material-ui/core';
import { VariableIcon, VariableValue } from '@timeflies/app-ui';
import React from 'react';
import { FeedbackEffectContainer } from './feedback-effect-container';
export var FeedbackEffect = function (_a) {
    var spellCategory = _a.spellCategory, variableName = _a.variableName, value = _a.value;
    return (React.createElement(FeedbackEffectContainer, { spellCategory: spellCategory },
        React.createElement(VariableValue, { variableName: variableName, value: value, relative: true, colored: true }),
        React.createElement(Box, { display: 'inline-flex', mx: 0.5 },
            React.createElement(VariableIcon, { variableName: variableName }))));
};
